import Oidc, { UserManager } from 'oidc-client'
import config from './config'
import router from '../routing/router'
import { bus } from '../main'

if (localStorage.getItem('oicdLog')) {
    Oidc.Log.logger = console
}

class AuthService {
    constructor () {
        this.userManager = new UserManager(config)
        this.user = {
            loggedIn: false,
            name: null,
            id: null
        }

        this.userManager.startSilentRenew()
    }

    async isAuthenticated () {
        const user = await this.getUser()
        const timestamp = Math.round((new Date()).getTime() / 1000)

        if (user && user.access_token && user.expires_at > timestamp) {
            return true
        } else {
            return false
        }
    }

    silentLogin () {
        return this.userManager.signinSilent()
            .then(user => {
                this.applyUser(user)
                return user
            })
            .catch(error => {
                if (error.error === 'login_required') {
                    console.info('Skipping silent login - authentication required')
                    return
                }
                console.error(error)
            })
    }

    login () {
        console.log('login')
        if (!isLocalStorageSupported()) {
            console.error('Anmeldung nicht möglich', 'Bitte verlasse den privaten Modus, um die Anmeldung zu nutzen.')
            return
        }

        this.userManager.signinRedirect()
            .catch(error => {
                console.error(error)
                console.error('Fehler bei der Anmeldung', 'Die Anmeldung ist leider nicht verfügbar. Wir werden das Problem so schnell wie möglich beheben.')
            })
    }

    async logout () {
      var cookies = document.cookie.split(';')

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i]
        var eqPos = cookie.indexOf('=')
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }
      localStorage.clear()
      await this.userManager.signoutRedirect()
        .catch(error => {
          console.log(error)
        })
        const url = config.authority + '/v2/logout?client_id=' + config.client_id + '&returnTo=https%3A%2F%2Fapp.soccerpresso.de'
        window.location = url
    }

    completeLogin () {
        this.userManager.signinRedirectCallback()
            .then(user => {
                this.loggedIn = true
                const path = localStorage.getItem('loginRedirect') || '/'

                localStorage.removeItem('loginRedirect')
                this.applyUser(user)
                router.push(path)
            })
            .catch(error => {
                console.error(error)
                router.push('/')
            })
    }

    applyUser (user) {
        if (user) {
            bus.$emit('user.changed', user)
            this.user.loggedIn = true
            this.user.name = user.profile.name
            this.user.id = user.profile.sub
            window.localStorage.setItem('access_token', user.access_token)
            return
        }

        this.user.loggedIn = false
        this.user.name = null
        this.user.id = null
    }

    getUser () {
        return this.userManager.getUser()
    }

    getToken () {
        return this.userManager.getUser()
            .then(user => {
                if (!user) {
                    return ''
                }

                return user.access_token
            })
    }

    getUserId () {
        return this.getUser()
            .then(user => {
                if (!user) {
                    return null
                }

                return user.profile.sub
            })
    }
}

export default new AuthService()

function isLocalStorageSupported () {
    try {
        localStorage.setItem('test', 'test')
    } catch (error) {
        console.warn(error)
        return false
    }

    return true
}
